import { toast, Bounce } from "react-toastify";
import {
  TOGGLE_DRAWER,
  TOGGLE_LOADING,
  TOGGLE_SNACKBAR,
  TOAST,
} from "../types";

const initialState = {
  drawer: false,
  loading: false,
  snackbar: false,
  snackbarMsg: "",
  toastMsg: {
    msg: "",
    type: "",
  },
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_DRAWER:
      return {
        ...state,
        drawer: !state.drawer,
      };
    case TOGGLE_LOADING:
      return {
        ...state,
        loading: !state.loading,
      };
    case TOGGLE_SNACKBAR:
      return {
        ...state,
        snackbarMsg: action.msg,
        snackbar: !state.snackbar,
      };
    case TOAST:
      let { msg, msgType, ...options } = action.payload;
      toast(msg, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
        transition: Bounce,
        type: msgType === 0 ? toast.TYPE.ERROR : toast.TYPE.DEFAULT,
        rtl: true,
        ...options,
      });
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default appReducer;
